import { io } from "socket.io-client";
import Cookies from "js-cookie";

const SOCKET_URL = "https://hellocer-backend.onrender.com";

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    const token = Cookies.get("accessToken");
    if (!token) return;

    if (this.socket?.connected) return;

    this.socket = io(SOCKET_URL, {
      auth: {
        token
      },
      transports: ["websocket"]
    });

    this.socket.on("connect", () => {
      console.log("Connected to WebSocket");
    });

    this.socket.on("connect_error", (error) => {
      console.error("WebSocket connection error:", error);
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinChat(chatId) {
    if (this.socket) {
      this.socket.emit("chat:join", chatId);
    }
  }

  leaveChat(chatId) {
    if (this.socket) {
      this.socket.emit("chat:leave", chatId);
    }
  }

  onNewMessage(callback) {
    if (this.socket) {
      this.socket.on("message:new", callback);
    }
  }

  onMessagesRead(callback) {
    if (this.socket) {
      this.socket.on("messages:read", callback);
    }
  }

  onUserTyping(callback) {
    if (this.socket) {
      this.socket.on("user:typing", callback);
    }
  }

  emitTyping(chatId, isTyping) {
    if (this.socket) {
      this.socket.emit("chat:typing", { chatId, isTyping });
    }
  }

  offNewMessage() {
    if (this.socket) {
      this.socket.off("message:new");
    }
  }

  offMessagesRead() {
    if (this.socket) {
      this.socket.off("messages:read");
    }
  }

  onNotification(callback) {
    if (this.socket) {
      this.socket.on("notification:new", callback);
    }
  }

  onNotificationRead(callback) {
    if (this.socket) {
      this.socket.on("notification:read", callback);
    }
  }

  onAllNotificationsRead(callback) {
    if (this.socket) {
      this.socket.on("notifications:all_read", callback);
    }
  }

  offNotification() {
    if (this.socket) {
      this.socket.off("notification:new");
      this.socket.off("notification:read");
      this.socket.off("notifications:all_read");
    }
  }
}

export default new SocketService();